var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "main_menu/menu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main_menu/menu",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64,21.4775 C64,17.0595 59.887,13.4775 53,13.4775 C46.113,13.4775 42,17.0595 42,21.4775 L64,21.4775 Z",
    id: "Fill-1",
    fill: "#9A9CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6826,36.4775 L45.3176,36.4775 C43.4856,36.4775 41.9996,34.9925 41.9996,33.1605 L41.9996,32.4775 L63.9996,32.4775 L63.9996,33.1605 C63.9996,34.9925 62.5146,36.4775 60.6826,36.4775",
    id: "Fill-3",
    fill: "#9A9CA0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#51C25D",
    points: "46 25.4776 68 25.4776 68 23.4776 46 23.4776"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#E04622",
    points: "42 30.4776 64 30.4776 64 27.4776 42 27.4776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,27.2548 L30,25.4778 L30.875,25.4778 C32.83,25.4778 34.41,23.8748 34.374,21.9118 C34.34,20.0208 32.65,18.4778 30.759,18.4778 L30,18.4778 L25.904,18.4778 L18,18.4778 L18,27.2548 C18,29.0348 19.443,30.4778 21.223,30.4778 L26.777,30.4778 C28.557,30.4778 30,29.0348 30,27.2548",
    id: "Fill-8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,25.4775 L30.646,25.4775 C32.56,25.4775 34.287,24.0465 34.371,22.1355 C34.46,20.1305 32.86,18.4775 30.875,18.4775 L30,18.4775 L30,25.4775 Z",
    id: "Fill-9",
    fill: "#BEC0C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4688,32.4775 C34.4688,34.6865 32.6778,36.4775 30.4688,36.4775 L17.0628,36.4775 C14.8538,36.4775 13.0628,34.6865 13.0628,32.4775 L34.4688,32.4775 Z",
    id: "Fill-10",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(12.000000, 43.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7246,13.4775 C52.3486,5.8945 43.8366,0.5105 33.8626,0.5105 C23.8886,0.5105 15.3756,5.8945 11.9996,13.4775 L55.7246,13.4775 Z",
    id: "Fill-11",
    fill: "#E04622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,13.4775 C15.376,21.0605 23.889,26.4445 33.862,26.4445 C43.837,26.4445 52.349,21.0605 55.725,13.4775 L12,13.4775 Z",
    id: "Fill-12",
    fill: "#F76E3C"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#F76E3C",
    points: "0 5.3779 0 21.4779 12 13.4279"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,13.9775 C50,16.4625 47.985,18.4775 45.5,18.4775 C43.015,18.4775 41,16.4625 41,13.9775 C41,11.4925 43.015,9.4775 45.5,9.4775 C47.985,9.4775 50,11.4925 50,13.9775",
    id: "Fill-14",
    fill: "#F76E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,13.9775 C48,15.3585 46.881,16.4775 45.5,16.4775 C44.119,16.4775 43,15.3585 43,13.9775 C43,12.5965 44.119,11.4775 45.5,11.4775 C46.881,11.4775 48,12.5965 48,13.9775",
    id: "Fill-15",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.3916,6 C26.6636,7.738 28.0576,10 26.3636,12.848 C25.4706,14.35 24.0576,15.563 24.3916,17.298 C22.4706,16.309 20.9036,14.024 22.7536,10.95 C23.8166,9.185 24.8596,7.471 24.3916,6",
    id: "Fill-16",
    fillOpacity: 0.25,
    fill: "#FFFFFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.2a822f8eac2592dfd9545555db571788.svg";
export { ForwardRef as ReactComponent };